import type { UseSearchOrderItemsParams } from './types';

export type UseSearchOrderItemsQueryKey = readonly [
  'search',
  'orderItems',
  UseSearchOrderItemsParams,
];

export const getUseSearchOrderItemsQueryKey = (
  params: UseSearchOrderItemsParams,
): UseSearchOrderItemsQueryKey => ['search', 'orderItems', params];
